/**
 * @file TranscriptField.jsx
 * @description
 *
 * options - array of strings: 
 * [
        "NM_003000.2",
        "NM_003001.3",
        "NM_003002.3"
   ]

   allows addition of a new string to the array.

 * 
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 05, 2026 18:51
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Autocomplete } from '@mui/material';

import VeriomeAutocompleteField from 'src/components/fieldComponents/VeriomeAutocompleteField';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

import { arrayExists, objectExists, stringExists } from 'src/@common/utilities';

function TranscriptField(props) {
    const {
        fieldName,
        fieldLabel,
        className,
        currentValue,  // string
        options,  // biocurations.transcripts array of strings
        fieldErrors = {},
        helpText = '',
        handleBlur = () => { },
        handleChange,
    } = props;

    const [helperText, setHelperText] = useState('');
    const [value, setValue] = useState('');

    useEffect(() => {
        // find the current value in the options
        if (stringExists(currentValue) &&
            arrayExists(options)) {

            const existingOption = options.find((item) => {
                return item === currentValue;
            });

            if (existingOption) {
                setValue(existingOption);
            } else {
                setValue('');
            }

        } else {
            setValue('');
        }

    }, [currentValue, options]);

    useEffect(() => {

        if (fieldErrors[fieldName]) {
            setHelperText(fieldErrors[fieldName])
        } else {
            if (objectExists(value)) {
                if (stringExists(helpText)) {
                    setHelperText(helpText);
                } else {
                    setHelperText(value.id)
                }
            } else {
                if (stringExists(helpText)) {
                    setHelperText(helpText);
                } else {
                    setHelperText('')
                }
            }
        }

    }, [fieldErrors, fieldName, helpText, value]);

    return (
        <div className={className} >

            <VeriomeAutocompleteField
                currentValue={currentValue ? currentValue : ''}
                fieldErrors={fieldErrors}
                fieldName={fieldName}
                fieldLabel={fieldLabel}
                helpText={helperText}
                options={options}
                sxStyle={{
                    width: '200px',
                    mr: '5px',
                    mb: '5px',
                }}
                handleBlur={() => {
                    handleBlur(fieldName);
                }}
                handleChange={(event) => {
                    // onChange(event)
                    handleChange(event, fieldName);
                }}
            />
        </div>
    );
}

TranscriptField.propTypes = {
    fieldLabel: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    className: PropTypes.string,
    currentValue: PropTypes.string,
    options: PropTypes.array,
    fieldErrors: PropTypes.object,
    helpText: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocus: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    isRequired: PropTypes.bool,
    sxStyle: PropTypes.object,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func.isRequired,
};

export default TranscriptField;
